<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<div class="customer-email-page-panel">
		<mat-card class="branding--customer-email-title-card branding--title-card">
			<mat-card-content>
				<div class="customer-email-title-card">
					<h1>{{ customerInternet?.id ? customerInternet?.address : ("CUSTOMER_DETAILS.EMAIL_DETAILS.TITLE_NEW_EMAIL_FOR" | translate) + " " + customer?.name }}</h1>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="branding--customer-email-detail-card  branding--section-card">
			<mat-card-content>
				<form [formGroup]="form" class="cass-customer-email-details-form">
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.EMAIL_DETAILS.EMAIL_ADDRESS" | translate }}</mat-label>
						<input matInput formControlName="address" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="address"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.EMAIL_DETAILS.DESCRIPTION" | translate }}</mat-label>
						<input matInput formControlName="description" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="description"></mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card class="branding--action-card button-container">
			<mat-card-content>
				<div class="button-container">
					<button mat-raised-button color="primary" [disabled]="!isValid()" (click)="modifyCustomerEmail()">{{ "ACTION_BUTTON_LABELS.SAVE" | translate }}</button>
					<button mat-stroked-button (click)="closeCustomerEmail()">{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}</button>
					<button *ngIf="customerInternet?.id" mat-stroked-button (click)='confirmDeleteCustomerEmail()'>{{ "ACTION_BUTTON_LABELS.DELETE" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
